import { Suspense } from "react";

const WaitingComponent = (Component, Fallback) => (props) => (
  <Suspense fallback={Fallback}>
    <Component {...props} key={window.location.pathname} />
  </Suspense>
);

export { WaitingComponent };
